// Helpers richtext : `**gras**` devient <strong>, les lignes vides séparent les paragraphes.

function escapeHtml(s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
}

export function toHtml(text) {
  if (!text) return ''
  return escapeHtml(text).replace(/\*\*(.+?)\*\*/gs, '<strong>$1</strong>')
}

export function toParagraphs(text) {
  if (!text) return []
  return text
    .split(/\n{2,}/)
    .map((p) => p.trim())
    .filter(Boolean)
    .map(toHtml)
}
